<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <DIV
    class="card my-3"
  >
    <DIV
      class="card-body"
    >
      <H5>
        {{ 'NAV online invoice interface'|gettext }}
      </H5>
      <P
        class="card-text"
      >
        {{ 'Import invoices from NAV online invoices service.'|pgettext('Tasks') }}
      </P>
    </DIV>
    <table
      class="table mb-0 mx-3 w-auto"
      :style="b_3343864469950044_style"
    >
      <tbody>
        <tr
          :key="item.company_id"
          v-for="item in items"
        >
          <td
            :style="b_5477420070495986_style"
          >
            <b-form-checkbox
              :disabled="item.not_configured"
              v-model="selectedCompanies[item.company_id]"
            >
              <ItpText
                strong
                :text="item.company_name"
              >
              </ItpText>
            </b-form-checkbox>
          </td>
          <td
            :style="b_6337614691287098_style"
          >
            <ItpBadge
              :text="'Not configured'|pgettext('NAVOnlineInvoiceInterface')"
              variant="warning"
              v-if="item.not_configured"
            >
            </ItpBadge>
          </td>
          <td
            :style="b_2406129194387753_style"
          >
            <ItpButton
              icon="mdi:cog"
              :text="'Configure'|pgettext('Tasks|Command')"
              @click="evh_5615156174146796_click($event, {item})"
            >
            </ItpButton>
          </td>
        </tr>
      </tbody>
    </table>
    <DIV
      class="card-footer bg-transparent"
    >
      <JobHandlerControl
        jobType="invoices:nav:pull-invoices"
        load-current
        :disabled="!selectedCompanyValues || !selectedCompanyValues.length"
        :payload="() => ({ companies: selectedCompanyValues })"
        :text="'Pull new invoices from NAV services.'|pgettext('Tasks|Command')"
        :icon="$config.pullDataIcon"
      >
      </JobHandlerControl>
    </DIV>
  </DIV>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class NAVOnlineInvoiceInterfacePanel extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
    this.$$cache_selectedCompanies = new ComponentValueCache(this, "selectedCompanies", "NAVOnlineInvoiceInterface.selectedCompanies");
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_nav_online_interface_setting').then(data => _.orderBy(data, ['company_name']))
  }

  selectedCompanies!: any;
  ux!: any;
  b_3343864469950044_style!: any;
  b_5477420070495986_style!: any;
  b_6337614691287098_style!: any;
  b_2406129194387753_style!: any;
  dataMembers = ['items', 'selectedCompanies', 'ux', 'b_3343864469950044_style', 'b_5477420070495986_style', 'b_6337614691287098_style', 'b_2406129194387753_style'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        selectedCompanies: {
        }
        ,
        ux: null,
        b_3343864469950044_style: {
          width: "1px",
        }
        ,
        b_5477420070495986_style: {
          width: "1px",
          "vertical-align": "middle",
        }
        ,
        b_6337614691287098_style: {
          width: "1px",
          "vertical-align": "middle",
        }
        ,
        b_2406129194387753_style: {
          width: "auto",
        }
        ,
      },
    }
  }

  get selectedCompanyValues() {
    if (this.loaded) {

      return _.keys(_.pickBy(this.selectedCompanies))
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_5615156174146796_showModal_5028_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5615156174146796_showModal_5028, alias=undefined
    return {
      name: "NAVOnlineInvoiceInterfaceSettings",
      props: {
        companyId: $event.scope.item.company_id,
      }
      ,
    }
  }

  async evh_5615156174146796_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5615156174146796_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_5026: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_5025: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_5615156174146796_reloadComponentData_5030: actions.ReloadComponentDataAction;
    evh_5615156174146796_close_5029: actions.EventHandlerImpl;
    act_5615156174146796_showModal_5028: actions.ShowModalAction;
    evh_5615156174146796_click_5027: actions.EventHandlerImpl;
    evh_5615156174146796_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_5026 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_5025 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_5026,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_5025],
      }
    );
    const act_5615156174146796_reloadComponentData_5030 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_5615156174146796_close_5029 = new actions.EventHandlerImpl(
      {
        action: act_5615156174146796_reloadComponentData_5030,
        event: "close",
        displayName: "reloadComponentData",
      }
    );
    const act_5615156174146796_showModal_5028 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5615156174146796_showModal_5028_getActionArgs,
        events: [evh_5615156174146796_close_5029],
      }
    );
    const evh_5615156174146796_click_5027 = new actions.EventHandlerImpl(
      {
        action: act_5615156174146796_showModal_5028,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_5615156174146796_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_5615156174146796_click_5027],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_5026,
      evh_7315092382398562_reload_5025,
      evh_7315092382398562_reload,
      act_5615156174146796_reloadComponentData_5030,
      evh_5615156174146796_close_5029,
      act_5615156174146796_showModal_5028,
      evh_5615156174146796_click_5027,
      evh_5615156174146796_click,
    }
  }
}

Vue.component("NAVOnlineInvoiceInterfacePanel", NAVOnlineInvoiceInterfacePanel);

</script>